import { render, staticRenderFns } from "./pointsExchange.vue?vue&type=template&id=ab86f8a0&scoped=true"
import script from "./pointsExchange.vue?vue&type=script&lang=js"
export * from "./pointsExchange.vue?vue&type=script&lang=js"
import style0 from "./pointsExchange.vue?vue&type=style&index=0&id=ab86f8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab86f8a0",
  null
  
)

export default component.exports